import React from "react";

import Table from "../../common/Table";
import Option from "../../common/RowOption";
import useParityAccess, { useAccessReady } from "../../common/useParityAccess";

import lbl from "../../../data/Labels.json";

const DiscountsList = ({ activeSem }) => {
  const can = useParityAccess();
  const ready = useAccessReady();
  const allow = (key) => !ready || can(key);
  const discountsColumns = [
    { path: "id", label: "شماره" },
    { path: "discount_type", label: "نوع تخفیف" },
    { path: "issue_date", label: "تاریخ صدور" },
    { path: "remark", label: "ملاحظه" },
    {
      path: "attachment",
      label: "سند",
      content: ({ attachment }) =>
        attachment && (
          <a href={attachment} download target="_blank">
            {lbl.Download}
          </a>
        ),
    },
    { path: "amount", label: "مبلغ" },
    {
      path: "option",
      content: (e) => (
        <Option
          Edit={allow("edit-student-discount") ? { form: "student-discount-form", cache: e.student_id, edit: e } : null}
          Delete={allow("delete-student-discount") ? { route: "students/discounts", id: e.id } : null}
        />
      ),
    },
  ];

  return (
    <div className="table-card">
      <p className="table-title">{lbl.Discounts}</p>
      <Table
        data={activeSem?.discounts}
        columns={discountsColumns}
        total={activeSem?.discount}
      />
    </div>
  );
};

export default DiscountsList;
